import React from 'react'

interface DefaultOrgIconProps {
  width?: number
  height?: number
  alt?: string
}

const DefaultOrgIcon: React.FC<DefaultOrgIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Default organization icon',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      aria-label={alt}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#E6F4FA' />
      <g clipPath='url(#clip0_4883_5014)'>
        <path
          d='M6.05586 17.1069H1.73828V12.6707L3.89707 10.458L6.05586 12.6707V17.1069Z'
          fill='#DDDDDD'
        />
        <path
          d='M16.1152 17.1071V8.21839L19.1678 5.58594L22.2203 8.21839V17.1071H16.1152Z'
          fill='white'
        />
        <path
          d='M19.168 5.58594L18.2959 6.33804L20.4763 8.21839V17.1071H22.2206V8.21839L19.168 5.58594Z'
          fill='#DDDDDD'
        />
        <path
          d='M6.04883 8.66621L9.28054 6.19336L12.5122 8.66621V17.1067H6.04883V8.66621Z'
          fill='#BBBBBB'
        />
        <path d='M12.5123 8.66621H6.04883L9.28054 6.19336L12.5123 8.66621Z' fill='#F64A5C' />
        <path
          d='M9.28018 12.2261C9.09952 12.2261 8.95312 12.0797 8.95312 11.899V10.2127C8.95312 9.78979 9.60724 9.78979 9.60724 10.2127V11.899C9.60724 12.0797 9.46085 12.2261 9.28018 12.2261Z'
          fill='#B8F0FF'
        />
        <path
          d='M10.8915 12.2261C10.7108 12.2261 10.5645 12.0797 10.5645 11.899V10.2127C10.5645 9.78979 11.2186 9.78979 11.2186 10.2127V11.899C11.2186 12.0797 11.0721 12.2261 10.8915 12.2261Z'
          fill='#B8F0FF'
        />
        <path
          d='M9.28018 15.4517C9.09952 15.4517 8.95312 15.3053 8.95312 15.1246V13.4382C8.95312 13.0154 9.60724 13.0154 9.60724 13.4382V15.1246C9.60724 15.3053 9.46085 15.4517 9.28018 15.4517Z'
          fill='#B8F0FF'
        />
        <path
          d='M10.8915 15.4517C10.7108 15.4517 10.5645 15.3053 10.5645 15.1246V13.4382C10.5645 13.0154 11.2186 13.0154 11.2186 13.4382V15.1246C11.2186 15.3053 11.0721 15.4517 10.8915 15.4517Z'
          fill='#B8F0FF'
        />
        <path d='M12.5068 5.50977H16.1149V17.1066H12.5068V5.50977Z' fill='#DDDDDD' />
        <path
          d='M7.66885 12.2261C7.48819 12.2261 7.3418 12.0797 7.3418 11.899V10.2127C7.3418 9.78979 7.99591 9.78979 7.99591 10.2127V11.899C7.99591 12.0797 7.84952 12.2261 7.66885 12.2261Z'
          fill='#B8F0FF'
        />
        <path
          d='M7.66885 15.4517C7.48819 15.4517 7.3418 15.3053 7.3418 15.1246V13.4382C7.3418 13.0154 7.99591 13.0154 7.99591 13.4382V15.1246C7.99591 15.3053 7.84952 15.4517 7.66885 15.4517Z'
          fill='#B8F0FF'
        />
        <path
          d='M19.9303 17.1067H12.5117V12.6659L14.3663 11.2578L16.221 12.6659H19.9303V17.1067Z'
          fill='white'
        />
        <path
          d='M19.9302 12.6659L18.0078 11.2578H14.3662L16.2209 12.6659H19.9302Z'
          fill='#F64A5C'
        />
        <path d='M16.2207 12.666H19.93V17.1067H16.2207V12.666Z' fill='#DDDDDD' />
        <path
          d='M14.3501 13.4744C14.771 13.4744 14.7717 12.8203 14.3501 12.8203C13.9292 12.8203 13.9285 13.4744 14.3501 13.4744Z'
          fill='#B8F0FF'
        />
        <path
          d='M15.0215 17.1065H13.6797V15.3428C13.6797 14.9722 13.9801 14.6719 14.3506 14.6719C14.7211 14.6719 15.0215 14.9722 15.0215 15.3428V17.1065Z'
          fill='#AB632E'
        />
        <path
          d='M17.4364 14.8177C17.2558 14.8177 17.1094 14.6712 17.1094 14.4906V13.9421C17.1094 13.5193 17.7635 13.5193 17.7635 13.9421V14.4906C17.7635 14.6712 17.6171 14.8177 17.4364 14.8177Z'
          fill='#B8F0FF'
        />
        <path
          d='M18.7118 14.8177C18.5312 14.8177 18.3848 14.6712 18.3848 14.4906V13.9421C18.3848 13.5193 19.0389 13.5193 19.0389 13.9421V14.4906C19.0389 14.6712 18.8925 14.8177 18.7118 14.8177Z'
          fill='#B8F0FF'
        />
        <path d='M16.1152 8.21839H22.2203L19.1678 5.58594L16.1152 8.21839Z' fill='#F64A5C' />
        <path
          d='M19.168 5.58594L18.2959 6.33804L20.4763 8.21839H22.2206L20.6943 6.90217L19.168 5.58594Z'
          fill='#CE0015'
        />
        <path d='M12.5176 5.50283L14.2 2.5L16.1033 5.50283H12.5176Z' fill='#BBBBBB' />
        <path
          d='M14.7839 9.22573H13.8379V7.91637C13.8379 7.65512 14.0496 7.44336 14.3109 7.44336C14.5722 7.44336 14.7839 7.65512 14.7839 7.91637V9.22573Z'
          fill='#B8F0FF'
        />
        <path
          d='M4.68936 15.4872C4.5087 15.4872 4.3623 15.3407 4.3623 15.1601V14.2429C4.3623 13.8201 5.01642 13.8201 5.01642 14.2429V15.1601C5.01642 15.3407 4.86998 15.4872 4.68936 15.4872Z'
          fill='#B8F0FF'
        />
        <path d='M3.89707 12.6707H1.73828L3.89707 10.458L6.05586 12.6707H3.89707Z' fill='#F64A5C' />
        <path
          d='M3.10635 15.4872C2.92569 15.4872 2.7793 15.3407 2.7793 15.1601V14.2429C2.7793 13.8201 3.43341 13.8201 3.43341 14.2429V15.1601C3.43341 15.3407 3.28702 15.4872 3.10635 15.4872Z'
          fill='#B8F0FF'
        />
        <path
          d='M17.5009 10.5072C17.3202 10.5072 17.1738 10.3608 17.1738 10.1802V9.44996C17.1738 9.0271 17.8279 9.0271 17.8279 9.44996V10.1802C17.8279 10.3608 17.6815 10.5072 17.5009 10.5072Z'
          fill='#B8F0FF'
        />
        <path
          d='M20.8124 10.5072C20.6317 10.5072 20.4854 10.3608 20.4854 10.1802V9.44996C20.4854 9.0271 21.1395 9.0271 21.1395 9.44996V10.1802C21.1395 10.3608 20.9931 10.5072 20.8124 10.5072Z'
          fill='#B8F0FF'
        />
        <path
          d='M19.1405 10.5072C18.9599 10.5072 18.8135 10.3608 18.8135 10.1802V9.44996C18.8135 9.0271 19.4676 9.0271 19.4676 9.44996V10.1802C19.4676 10.3608 19.3212 10.5072 19.1405 10.5072Z'
          fill='#B8F0FF'
        />
        <path d='M0 17H24V24H0V17Z' fill='#88E3C3' />
        <path d='M21 17H24V24H21V17Z' fill='#88E3C3' />
        <path
          d='M21.0676 19.8431C21.5909 19.7768 22.2591 19.7402 22.8361 19.7402V18.3231C17.3782 18.2255 10.4338 19.6053 6.49316 24.0002H13.3951C15.2815 21.6067 18.1466 20.3769 21.0676 19.8431Z'
          fill='#D2F6FF'
        />
        <path
          d='M5.25573 18.981C5.25573 19.6039 4.75076 20.1088 4.12787 20.1088C3.50498 20.1088 3 19.6039 3 18.981C3 18.3581 3.50498 16 4.12787 16C4.75076 16 5.25573 18.3581 5.25573 18.981Z'
          fill='#00B47E'
        />
        <path
          d='M3.80078 21.4519V18.7001C3.80078 18.5195 3.94717 18.373 4.12784 18.373C4.3085 18.373 4.45489 18.5195 4.45489 18.7001V21.4519H3.80078Z'
          fill='#AB632E'
        />
        <path
          d='M8.25573 17.981C8.25573 18.6039 7.75076 19.1088 7.12787 19.1088C6.50498 19.1088 6 18.6039 6 17.981C6 17.3581 6.50498 15 7.12787 15C7.75076 15 8.25573 17.3581 8.25573 17.981Z'
          fill='#00B47E'
        />
        <path
          d='M7.12784 20.778C6.94717 20.778 6.80078 20.6316 6.80078 20.4509V17.6991C6.80078 17.5185 6.94717 17.3721 7.12784 17.3721C7.3085 17.3721 7.45489 17.5185 7.45489 17.6991V20.4509C7.45489 20.6316 7.3085 20.778 7.12784 20.778Z'
          fill='#AB632E'
        />
        <path
          d='M21.2557 17.981C21.2557 18.6039 20.7508 19.1088 20.1279 19.1088C19.505 19.1088 19 18.6039 19 17.981C19 17.3581 19.505 15 20.1279 15C20.7508 15 21.2557 17.3581 21.2557 17.981Z'
          fill='#00B47E'
        />
        <path
          d='M20.1278 20.779C19.9472 20.779 19.8008 20.6326 19.8008 20.452V17.7001C19.8008 17.5195 19.9472 17.373 20.1278 17.373C20.3085 17.373 20.4549 17.5195 20.4549 17.7001V20.452C20.4549 20.6326 20.3085 20.779 20.1278 20.779Z'
          fill='#AB632E'
        />
        <path
          d='M22.8361 18.3231C22.2691 18.3129 21.6859 18.319 21.0918 18.3425V19.8401C21.6114 19.7757 22.2678 19.7401 22.8361 19.7401V18.3231Z'
          fill='#B8F0FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_4883_5014'>
          <rect width='22' height='22' fill='white' transform='translate(1 2)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DefaultOrgIcon
